import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'bnb'),
  es: flattenMessages(es, 'bnb'),
  ru: flattenMessages(ru, 'bnb'),
  zh: flattenMessages(zh, 'bnb'),
};
